import { Component, OnDestroy, OnInit } from '@angular/core';
import { Revisione53CoreSelectors } from '../../../store/selectors/core.selectors';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { format } from 'date-fns';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { IndexedDBService } from '@core/services/indexeddb.service';
import { CoreSelectors } from '@core/store/core.selectors';
import { HttpClient } from '@angular/common/http';
import { CryptoService } from '@core/services/crypto.service';
import { ToastrService } from 'ngx-toastr';
import { Revisione53Service } from '../../../revisione53.service';
import { ModalService } from '@core/services/modal.service';
import { environment } from '@env';

@Component({
    selector: 'app-salva-su-server',
    templateUrl: './salva-su-server.component.html',
    styleUrls: ['./salva-su-server.component.scss'],
})
export class SalvaSuServerComponent implements OnInit, OnDestroy {
    isOnline$: Observable<boolean>;
    lastSave$: Observable<Date>;
    isCurrentlySaving: boolean;
    modalMessage: string;
    autosaveIntervalTask: any;
    counter: number = environment.autoSaveIntervalMs;
    counterTxt: string;
    counterFn: any;

    constructor(
        private store: Store<Revisione53State>,
        private indexedDb: IndexedDBService,
        private http: HttpClient,
        private cryptoService: CryptoService,
        private toastr: ToastrService,
        private revisioneService: Revisione53Service,
        private modalService: ModalService
    ) {
        this.isOnline$ = this.store.select(CoreSelectors.isOnline);
        this.lastSave$ = this.store.select(Revisione53CoreSelectors.getLastSave).pipe(map((local) => new Date(local.dataultimosalvataggio)));
        this.isCurrentlySaving = revisioneService.isCurrentlySaving;
    }

    ngOnInit() {
        this.initAutoSave();
    }

    salvaSuPc(): void {
        this.revisioneService.save(false).subscribe();
    }

    salvaSuServer(): void {
        this.isOnline$
            .pipe(
                take(1),
                filter((isOnline) => !!isOnline),
                switchMap(() => this.checkDateAndSave(false))
            )
            .subscribe(() => this.initCountdown());
    }

    private initAutoSave(): void {
        this.initCountdown();
        this.autosaveIntervalTask = setInterval(() => {
            this.checkDateAndSave(true).subscribe(() => {
                this.initCountdown();
                this.toastr.success(`Salvataggio automatico delle ore ${format(new Date(), 'HH:mm:ss')} effettuato correttamente`, null, { timeOut: 1500 });
            });
        }, this.counter);
    }

    private initCountdown(): void {
        clearInterval(this.counterFn);
        const cdate = new Date().getTime() + this.counter + 1000;
        this.counterFn = setInterval(() => this.countdown(cdate), 1000);
    }

    private countdown(cdate: number): void {
        const now = new Date().getTime();
        const dist = cdate - now;
        let minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((dist % (1000 * 60)) / 1000);
        if (seconds < 0) {
            minutes = 0;
            seconds = 0;
        }
        this.counterTxt = minutes + 'm ' + seconds + 's ';
        if (dist <= 0) {
            clearInterval(this.counterFn);
        }
    }

    // private save(upload: boolean, showSpinner = true): Observable<any> {
    //   if (upload) {
    //     this.store.dispatch(revisione53CoreActions.autosaveDataUltSalvataggio())
    //   }

    //   return this.store.select(Revisione53CoreSelectors.getRevisioneAndDatiBusiness).pipe(
    //     take(1),
    //     tap(() => this.isCurrentlySaving = true),

    //     mergeMap(({revisione, datiBusiness}) => {
    //       return this.revisioneService.getRevisioneWithBase64Files({revisione}).pipe(
    //         map(revisioneWithBase64Files => ({revisione: revisioneWithBase64Files, datiBusiness}))
    //       )
    //     }),
    //     mergeMap((revisioneAndDatiBusiness: IRevisioneDatiBusiness) => {
    //       if (upload) {
    //         return this.sendJsonToServer(revisioneAndDatiBusiness, showSpinner);
    //       } else {
    //         return this.downloadJson(revisioneAndDatiBusiness);
    //       }
    //     }),
    //     tap(() => {

    //       this.isCurrentlySaving = false;
    //       this.spinner.hide();
    //     })
    //   )
    // }

    // private sendJsonToServer(revisioneDatiBusiness: IRevisioneDatiBusiness, showSpinner = true): Observable<any> {
    //   TODO: dobbiamo mandare solo revisione oppure anche datiBusiness?

    //   const options = {
    //     headers: {
    //       showSpinner: String(showSpinner)
    //     }
    //   }

    //   return this.http.post('/salva-su-server', revisioneDatiBusiness, options);
    // }

    // private downloadJson(revisioneDatiBusiness: IRevisioneDatiBusiness): Observable<void> {
    //   return new Observable<void>(subscriber => {
    //     const encryptPsw = prompt('Inserisci una password per proteggere il backup che verrà scaricato');

    //     if (!encryptPsw) {
    //       this.toastr.error('È obbligatorio impostare una password per proseguire', 'Errore');
    //       subscriber.next();
    //       subscriber.complete();
    //       return
    //     }

    //     let json = JSON.stringify(revisioneDatiBusiness, undefined, 4);
    //     json = this.cryptoService.encrypt(json, encryptPsw);

    //     const dataStr = "data:text/plain;charset=utf-8," + json;
    //     const dlAnchorElem = document.createElement('a');
    //     dlAnchorElem.setAttribute('href', dataStr);

    //     const currentDate = format(new Date(), 'yyyyMMdd-HHmmss')

    //     const fileName = `revisione53-${currentDate}.backup`

    //     dlAnchorElem.setAttribute('download', fileName);
    //     dlAnchorElem.click();

    //     dlAnchorElem.remove();

    //     subscriber.next();
    //     subscriber.complete();
    //   })
    // }

    checkDateAndSave(fromAutosave: boolean = false): Observable<any> {
        return this.revisioneService.localRemoteLastSave$().pipe(
            switchMap((res) => {
                if (res.same) {
                    // se la revisione in locale e quella remota hanno la stessa data, il salvataggio viene effettuato normalmente
                    return this.revisioneService.save(true, false);
                } else {
                    const formatDate = (date: Date) => format(date, 'dd/MM/yyyy - HH:mm:ss');
                    let overwrite = true;
                    if (res.remote.dataultimosalvataggio > 0) {
                        const remoteDateFormat = formatDate(new Date(res.remote.dataultimosalvataggio));
                        const localDateFormat = formatDate(new Date(res.local.dataultimosalvataggio));

                        if (res.remote.dataultimosalvataggio > res.local.dataultimosalvataggio) {
                            overwrite = confirm(
                                '' +
                                    'La versione sul cloud (' +
                                    remoteDateFormat +
                                    ') risulta più recente rispetto a quella ' +
                                    'salvata sul tuo client (' +
                                    localDateFormat +
                                    '). La versione sul cloud potrebbe essere stata lavorata da altri dispositivi.\n' +
                                    'Desideri sovrascrivere la versione online con quella presente sul tuo client?'
                            );
                        }
                        // else {
                        //   overwrite = confirm('' +
                        //       'La versione sul tuo client ('+localDateFormat+') ('+ res.local.md5 +') risulta più recente rispetto a quella ' +
                        //       'salvata sul cloud ('+remoteDateFormat+') ('+ res.remote.md5 +').\n' +
                        //       'Desideri sovrascrivere la versione online con quella presente sul tuo client?');
                        // }
                    }

                    if (overwrite) {
                        return this.revisioneService.save(true, false);
                    } else {
                        //const idRevisione = new URLSearchParams(window.location.search).get('idRevisione')
                        //sessionStorage.removeItem(`confcooperative-revisione53-${idRevisione}`);
                        //window.location.reload();
                        return;
                    }
                }
            }),
            tap((res) => {
                if (!fromAutosave) this.toastr.success(`Salvataggio manuale sul server effettuato correttamente`, null, { timeOut: 1500 });
            })
        );
    }

    ngOnDestroy(): void {
        clearInterval(this.autosaveIntervalTask);
    }
}
